import { GridCellProps } from '@progress/kendo-react-grid';
import React, { useCallback, useContext, useMemo } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { errorIcon } from 'src/utils/icons';
import GridCellBase from '../GridCellBase';
import PopUpContentWrapper from '../PopUpContentWrapper';
import PopUp from '../design-system/PopUp';

const InvoiceErrorCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const errorType = useMemo(() => dataItem?.closePoError, [dataItem?.closePoError]);
  const hasError = errorType !== 'WithoutError';
  const [cellClick] = useContext(EditCellContext);
  const { onClosePoErrorQtyClick } = cellClick?.(null);
  const errorList = useMemo(() => {
    let errors: string[] = [];
    if (errorType === 'DocumentError') {
      errors.push(
        'This PO record has invoices or credit memo documents that require further review before the PO can be closed.'
      );
    } else if (errorType === 'QuantityError') {
      errors.push(
        'This requires review to close PO because the invoiced qty is less than the qty approved in PO. Click to close the PO anyways.'
      );
    }

    return errors;
  }, [errorType]);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (errorType === 'QuantityError') {
        onClosePoErrorQtyClick(dataItem);
      }

      event.nativeEvent.stopImmediatePropagation();
      event.stopPropagation();
    },
    [dataItem, errorType, onClosePoErrorQtyClick]
  );

  return (
    <GridCellBase
      {...props}
      className={`${hasError ? 'bg-error bg-opacity-25' : ''}`}
      disableToolTip
    >
      <PopUp
        content={<PopUpContentWrapper contents={errorList} type="Action Required" />}
        show={hasError}
      >
        <div className="flex items-center justify-center" onClick={handleClick}>
          {hasError ? errorIcon : ''}
        </div>
      </PopUp>
    </GridCellBase>
  );
};

export default InvoiceErrorCell;
